import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Lemonade Shoes' "PHOENIX - Statement Boot"
// (p_c69zqax92s), read from GET /api/product-reviews/product/p_c69zqax92s —
// verbatim comment, real reviewer, real rating, real publish date.
export const review_ls1: FaireReviewEntity = {
  token: "review_ls1",
  type: "review",
  brandName: "Lemonade Shoes",
  brandToken: "b_mz3xxxsvnf",
  productToken: "p_c69zqax92s",
  reviewType: "product",
  reviewerName: "Deborah H.",
  reviewerLocation: "Langley, BC",
  stars: 5,
  reviewText: "I love these! Plain & simple.",
  reviewDate: "Jul 22, 2026",
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:55:00.000Z",
    importedBy: "entity-db-cli",
  },
};
